const GA_MEASUREMENT_ID = 'G-6W8VC5MT87';

/**
 * Track a custom GA4 event
 */
export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (typeof window.gtag !== 'function') {
    console.warn('Google Analytics is not initialized');
    return;
  }

  window.gtag('event', eventName, parameters);
};

/**
 * Track a page view
 */
export const trackPageView = (pagePath, pageTitle = document.title) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (typeof window.gtag !== 'function') {
    console.warn('Google Analytics is not initialized');
    return;
  }

  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: pagePath,
    page_title: pageTitle
  });
};

/**
 * Set authenticated MLAS user
 */
export const setAnalyticsUser = (userId, userName, role) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (typeof window.gtag !== 'function') {
    return;
  }

  if (!userId) {
    return;
  }

  // Set authenticated user
  window.gtag('config', GA_MEASUREMENT_ID, {
    user_id: String(userId),
    send_page_view: false
  });

  // Set user properties
  window.gtag('set', 'user_properties', {
    user_name: userName || undefined,
    role: role || undefined
  });
};
